export default function initCharCount() {
  const textareas = document.querySelectorAll<HTMLTextAreaElement>('textarea[data-characters-recommended], textarea[data-val-length-max]');

  textareas.forEach(textarea => {

    const recommendedCharCount = textarea.dataset.charactersRecommended ? parseInt(textarea.dataset.charactersRecommended) : null;
    const maxCharCount = textarea.dataset.valLengthMax ? parseInt(textarea.dataset.valLengthMax) : null;

    if (recommendedCharCount && maxCharCount == null) return;

    const charCount = document.createElement("div");
    charCount.classList.add("char-count", "float-end", "fs-10");
    textarea.insertAdjacentElement('afterend', charCount);

    const updateCharCount = () => {
      const newlineCount = (textarea.value.match(/\n/g) || []).length;
      const length = textarea.value.length + newlineCount;

      if (maxCharCount !== null && length > maxCharCount) {
        charCount.classList.add("text-danger");
      } else {
        charCount.classList.remove("text-danger");
      }

      if (recommendedCharCount !== null && length >= recommendedCharCount) {
        charCount.classList.add("text-success");
      } else {
        charCount.classList.remove("text-success");
      }

      let charCountText = `${length}`;
      if (recommendedCharCount !== null) {
        charCountText += ` / ${recommendedCharCount} recommended`;
      }
      if (maxCharCount !== null) {
        charCountText += ` / ${maxCharCount} max`;
      }
      charCount.textContent = charCountText;
    };

    textarea.addEventListener("input", updateCharCount);
    updateCharCount();
  });
}
